<template>
  <div>
    <Pane v-if="!inModal" :title="'员工瓴云账号信息填写表'" />

    <div :class="{ container: !inModal }">
      <BranchEmployeeAccountForm
        ref="form"
        :detailData="detailData"
        @submit="handleSubmit"
        @close="handleClose"
      />
    </div>
  </div>
</template>

<script>
import BranchEmployeeAccountForm from "./form.vue";
import { add } from "@/api/human-resources/branchEmployee";

export default {
  name: "BranchEmployeeAccountAdd",

  components: { BranchEmployeeAccountForm },

  props: {
    // 是否在弹窗中使用
    inModal: { type: Boolean, default: false },
    // 详情数据（弹窗传入时用于回显）
    detailData: { type: Object, default: null },
  },

  methods: {
    handleSubmit(payload) {
      this.$refs.form.setLoading(true);
      add(payload)
        .then(() => {
          this.$message.success("提交成功");
          this.$emit("success");
          this.handleClose();
        })
        .finally(() => {
          this.$refs.form.setLoading(false);
        });
    },

    handleClose() {
      if (this.inModal) {
        this.$emit("close");
      } else {
        this.$close(this.$route.path);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 24px 160px;
}
</style>
